import React, { useEffect, useRef, useState } from 'react';
import styles from './UIGameCardAnimatorItem.module.scss';
import { UIGameCard } from '../../common/UIGameCard/index.ts';
import { getDistance } from '@colonist/utils';
export const UIGameCardAnimatorItem = ({ id, card, from, to, speed, delay, onComplete })=>{
    const [animationEnded, setAnimationEnded] = useState(false);
    const ref = useRef(null);
    useEffect(()=>{
        const element = ref.current;
        if (!element) return;
        element.style.transform = `translate(${from.x}px, ${from.y}px)`;
        void element.offsetWidth // force layout recalculation
        ;
        const distance = getDistance(from, to);
        const duration = distance / speed;
        element.style.transition = `transform ${duration}ms linear ${delay}ms`;
        element.style.transform = `translate(${to.x}px, ${to.y}px)`;
        const onTransitionEnd = ()=>{
            onComplete === null || onComplete === void 0 ? void 0 : onComplete(id);
            setAnimationEnded(true);
        };
        element.addEventListener('transitionend', onTransitionEnd);
        return ()=>{
            element.removeEventListener('transitionend', onTransitionEnd);
        };
    }, [
        id,
        from,
        to,
        speed,
        delay,
        onComplete
    ]);
    if (animationEnded) return null;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: styles.container
    }, /*#__PURE__*/ React.createElement(UIGameCard, card));
};
